import './team.css'
import teamImg1 from '../../assets/images/team-img-1.png'
import teamImg2 from '../../assets/images/team-img-2.png'
import teamImg3 from '../../assets/images/team-img-3.png'
import teamImg4 from '../../assets/images/team-img-4.png'

const Team = () => {
    return (
        <div className="team-area pt-100 pb-100">
            <div className="container">
                <div className="section-title">
                    <span className="top-title">Our Team</span>
                    <h2>Our Service Team</h2>
                </div>
                <div className="row">
                    <div className="col-lg-3 col-sm-6 col-md-6">
                        <div className="single-team-card">
                            <div className="team-img">
                                <a href="#">
                                    <img src={teamImg1} alt="images" />
                                </a>
                            </div>
                            <div className="single-team-card-content">
                                <a href="team.html"><h3>Anthony Dylan</h3></a>
                                <p>Cleaning Expert</p>
                                <ul className="team-list">
                                    <li>
                                        <a href="https://www.facebook.com/" target="_blank">
                                            <i className="flaticon-facebook"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://twitter.com/" target="_blank" className="border-twitter">
                                            <i className="flaticon-twitter"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.youtube.com/" target="_blank">
                                            <i className="flaticon-youtube"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.instagram.com/" target="_blank" className="border-twitter">
                                            <i className="flaticon-instagram"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-md-6">
                        <div className="single-team-card">
                            <div className="team-img">
                                <a href="#">
                                    <img src={teamImg2} alt="images" />
                                </a>
                            </div>
                            <div className="single-team-card-content">
                                <a href="team.html"><h3>Sofia Avery</h3></a>
                                <p>Cleaning Expert</p>
                                <ul className="team-list">
                                    <li>
                                        <a href="https://www.facebook.com/" target="_blank">
                                            <i className="flaticon-facebook"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://twitter.com/" target="_blank" className="border-twitter">
                                            <i className="flaticon-twitter"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.youtube.com/" target="_blank">
                                            <i className="flaticon-youtube"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.instagram.com/" target="_blank" className="border-twitter">
                                            <i className="flaticon-instagram"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-md-6">
                        <div className="single-team-card">
                            <div className="team-img">
                                <a href="#">
                                    <img src={teamImg3} alt="images" />
                                </a>
                            </div>
                            <div className="single-team-card-content">
                                <a href="team.html"><h3>Lincoln Thomas</h3></a>
                                <p>Cleaning Expert</p>
                                <ul className="team-list">
                                    <li>
                                        <a href="https://www.facebook.com/" target="_blank">
                                            <i className="flaticon-facebook"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://twitter.com/" target="_blank" className="border-twitter">
                                            <i className="flaticon-twitter"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.youtube.com/" target="_blank">
                                            <i className="flaticon-youtube"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.instagram.com/" target="_blank" className="border-twitter">
                                            <i className="flaticon-instagram"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-md-6">
                        <div className="single-team-card" >
                            <div className="team-img">
                                <a href="#">
                                    <img src={teamImg4} alt="images" />
                                </a>
                            </div>
                            <div className="single-team-card-content">
                                <a href="team.html"><h3>Scarlett Emily</h3></a>
                                <p>Cleaning Expert</p>
                                <ul className="team-list">
                                    <li>
                                        <a href="https://www.facebook.com/" target="_blank">
                                            <i className="flaticon-facebook"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://twitter.com/" target="_blank" className="border-twitter">
                                            <i className="flaticon-twitter"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.youtube.com/" target="_blank">
                                            <i className="flaticon-youtube"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.instagram.com/" target="_blank" className="border-twitter">
                                            <i className="flaticon-instagram"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Team